<template>
	<div v-bar>
        <div @scroll="getNextUsers" ref="searchList">
            <div id="results" data-id="results"  v-if="results.conversations.length > 0 || results.users.length > 0" >
                <div v-if="results.conversations.length > 0">
                    <div class="" v-for="result in results.conversations" :key="result.id" :ref="'result' + result.id">
                        <thread-item
                            :activeThread="activeThread"
                            @item-click="setActiveThread"
                            :showOnly="true"
                            :userId="result.id"
                        >
                        </thread-item>
                    </div>
                </div>
                <div class="tw-w-full tw-px-10" v-if="!showAllUsers && results.users.length > 0">
                    <div class="tw-w-full tw-h-px tw-bg-gray-200 tw-my-6"></div>
                    <p class="tw-font-semibold tw-text-2xl tw-mb-2">{{translations['messages.start_new_chat']}}</p>
                </div>
                <div v-if="results.users.length > 0">
                    <div class="" v-for="result in results.users" :key="result.id" :ref="'result' + result.id">
                        <search-item :result="result" v-on="$listeners" ></search-item>
                    </div>
                </div>
                <div v-if="showLoader" class="tw-py-4 tw-px-4 tw-bg-white tw-font-3xl tw-text-center">
                    <i class="fa fa-spinner fa-spin tw-text-2xl tw-text-gray-300"></i>
                </div>
            </div>
            <div v-show="noResults" class="w-full">
                <p class="tw-my-4 tw-text-center">{{ translations['messages.no_user_results'] }}</p>
            </div>
            <div v-show="error" class="w-full">
                <p class="tw-my-4 tw-text-center tw-text-red-500">{{ translations['messages.error_fetching_users'] }}</p>
            </div>
            <div v-show="!noResults && !error && results.users.length + results.conversations.length === 0 && searchQuery.length > 0">
                <div class="search-skeleton-wrapper tw-relative tw-overflow-hidden">
                    <div v-for="index in 10" :key="index" class="thread-skeleton-item tw-flex tw-items-center tw-p-5 tw-m-5">
                        <div class="avatar tw-w-16 tw-h-16 tw-rounded-full tw-mr-4 tw-bg-gray-200"></div>

                        <div>
                            <div class="name tw-h-5 tw-w-40 tw-mb-2 tw-bg-gray-200 tw-rounded" ></div>
                            <div class="username tw-h-4 tw-w-24 tw-bg-gray-200 tw-rounded"></div>
                        </div>
                    </div>

                    <div class="skeleton-animation"></div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import SearchItem from './SearchItem';
import Global from '../../mixins/Global.js';
import ThreadItem from './ThreadItem';
import Notification from '@/resources/assets/js/vue/lib/models/Notification';

const debounce = require('lodash.debounce');

function isInViewport(el) {
	const rect = el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
            (window.innerHeight ||
                document.documentElement.clientHeight) &&
        rect.right <=
            (window.innerWidth ||
                document.documentElement.clientWidth)
	);
}

export default {
	name: 'SearchList',
	props: ['searchQuery', 'showAllUsers', 'activeThread'],
	mixins: [Global],
	components: {
		'search-item': SearchItem,
		'thread-item': ThreadItem,
	},
	data() {
		return {
			results: {
				conversations: [],
				users: []
			},
			curPageUsers: 1,
			curPageConversations: 1,
			curPageAllUsers: 1,
			lastPageUsers: null,
			lastPageConversations: null,
			lastPageAllUsers: null,
			usersFetched: false,
			fetching: 'conversations',
			noResults: false,
			error: false,
			showLoader: false,
		};
	},
	computed: {
		conversationsLastPage() {
			return this.curPageConversations === this.lastPageConversations ? true : false;

		},
		usersLastPage() {
			return this.curPageUsers === this.lastPageUsers ? true : false;
		},
	},
	watch: {
		searchQuery: function(oldQuery, newQuery) {
			if (oldQuery !== newQuery) {
				this.getResults();
			}
		},
		showAllUsers: function(oldQuery, newQuery) {
			if (oldQuery !== newQuery) {
				this.results.users = [];
				this.getResults();
			}
		},
	},
	methods: {
		getAllUsers(){
			this.usersFetched = false;
			this.error = false;
			const url = `/api/v3/users?page=${this.curPageAllUsers}`;
			// const url = `/api/v3/users?page=${pageId}`;

			if(this.lastPageAllUsers === null || this.curPageAllUsers <= this.lastPageAllUsers) {
				fetch(url)
					.then((response) => response.json())
					.then((data) => {

						this.usersFetched = true;
						const results = [...data.data];
						this.results.users.push(...results);
						this.lastPageAllUsers = data.meta.last_page;
						this.curPageAllUsers += 1;
						this.showLoader = false;
					}).catch((error) => {
						this.error = true;
						Notification.insert({
							data: [
								{
									title: `${this.$t('messages.error_fetching_users')}. ${error}`,
									status: 'error',
								},
							],
						});
					});
			}
		},
		setActiveThread(id) {
			this.$emit('set-active-thread', id);
		},
		displayNextPage() {


			if (this.usersLastPage && this.conversationsLastPage) {
				if(this.results.conversations.length + this.results.users.length === 0) {
					this.noResults = true;
				}
				return;
			}

			const allResults = [...this.results.conversations, ...this.results.users];
			const lastResult = allResults[allResults.length -1];

			this.$nextTick(() => {
				if(lastResult) {
					const check = this.$refs['result' + lastResult.id][0];

					// if the last fetched result of this page is in viewport
					// we can display more  results, so fetch next page

					// check if we reached the last page of conversations, if not, load conversations
					// if we reached the last page, continue to display users, so check if we are on the last page of users, if not, display users
					if (isInViewport(check)) {
						if(!this.conversationsLastPage || !this.usersLastPage) {
							this.getResults(false);
						}
					}
				} else {
					// apparently there are no active chats displayed, so continue searching for other users we have no chat with
					if(!this.usersLastPage) {
						this.getResults(false);
					} else{
						if(this.results.conversations.length + this.results.users.length === 0) {
							this.noResults = true;
						}
					}
				}
			});


		},

		getNextUsers() {
			if (this.usersFetched === true) {
				const div = this.$refs.searchList;

				// *0.90 to load just before user reaches the end of the list
				const bottomOfWindow =
					Math.abs(div.scrollTop) + div.clientHeight >= div.scrollHeight * 0.95;

				if (bottomOfWindow) {
					this.showLoader = true;

					if(this.showAllUsers) {
						this.getAllUsers(false);
					} else  {
						this.getResults(false);
					}
				}
			}
		},

		getResults: debounce(function(replace = true) {
			this.usersFetched = false;
			this.noResults = false;
			this.error = false;

			const has_conversation_url = `/api/v3/search?query=${this.searchQuery}&model=users&page=${this.curPageConversations}&inbox=has_conversation`;
			const has_no_conversation_url = `/api/v3/search?query=${this.searchQuery}&model=users&page=${this.curPageUsers}&inbox=has_no_conversation`;

			let url;
			// if we reached the last page with users that we have a conversation with, change the url to no conversation
			if(this.curPageConversations === this.lastPageConversations) {
				this.fetching = 'users';
				url = has_no_conversation_url;
			} else {
				url = has_conversation_url;
			}

			if(this.fetching === 'users' && this.lastPageUsers !== null && this.curPageUsers === this.lastPageUsers) return;

			fetch(url)
				.then((response) => response.json())
				.then((data) => {
					const dataArr = [];
					Object.values(data.results.users.data).forEach((item) => {
						dataArr.push(item);
					});

					if(this.fetching === 'conversations') {
						if(replace) {
							this.results.conversations = dataArr;
						} else {
							this.results.conversations.push(...dataArr);
						}
						this.lastPageConversations = data.results.users.meta.pagination.last_page;
						if(this.curPageConversations !== data.results.users.meta.pagination.last_page) {
							this.curPageConversations += 1;
						}
					} else {
						if(replace) {
							this.results.users = dataArr;
						} else {
							this.results.users.push(...dataArr);
						}
						this.lastPageUsers = data.results.users.meta.pagination.last_page;
						if(this.curPageUsers !== data.results.users.meta.pagination.last_page) {
							this.curPageUsers += 1;
						}
					}


					this.usersFetched = true;

					if(this.curPageConversations !== this.lastPageConversations || this.curPageUsers !== this.lastPageUsers) {
						this.displayNextPage();
					} else if(this.results.conversations.length + this.results.users.length === 0) {
						this.noResults = true;
					}
				}).catch((error) => {
					this.error = true;
					Notification.insert({
						data: [
							{
								title: `${this.$t('messages.error_fetching_users')}. ${error}`,
								status: 'error',
							},
						],
					});
				});
		}, 400)
	},
	mounted() {
		if(this.showAllUsers) {
			// this.getAllUsers(); // disabled because /api/v3/users is no longer accessible for non-admins
		} else {
			this.getResults();
		}
	},
};
</script>

<style lang="scss" scoped>
	.search-skeleton-wrapper {
		.skeleton-animation {
            @apply tw-top-0 tw-absolute tw-opacity-50 tw-bg-white;
			height: 110%;
			width: 50px;
			transform: rotate(15deg);
			-webkit-animation: loading-topic-skeleton 1.5s ease infinite;
			animation: loading-topic-skeleton 1.5s ease infinite;
		}

        .thread-skeleton-item {
            &:first-of-type {
                margin-top: 0;
            }
        }
	}

	@-webkit-keyframes loading-topic-skeleton {
		0% {
			left: -50%;
		}
		100% {
			left: 110%;
		}
	}

	@keyframes loading-topic-skeleton {
		0% {
			left: -50%;
		}
		100% {
			left: 110%;
		}
	}

</style>
